import template from "./pCasemanCustomizeProcess.html";

export function pCasemanCustomizeProcessDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanCustomizeProcessController,
    controllerAs: 'pCasemanCustomizeProcess',
    bindToController: true
  };

  return directive;
}

class pCasemanCustomizeProcessController {
  constructor($scope, $interval, $routeParams, $q, Auth, Caseman, Notes, Sort, Utils, $location, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.clients = [];
    this.currentProjects = [];
    this.client = {
      id: this.$routeParams.clientId,
      userId: this.$routeParams.userId,
      userName: this.$routeParams.userId && this.$routeParams.name,
      projectId: this.$routeParams.projectId,
      projectName: this.$routeParams.projectName,
      teamId: this.$routeParams.teamId,
      teamName: this.$routeParams.teamId && this.$routeParams.name
    };

    this.processToMatch = {clientId: this.client.id};
    this.interruptToMatch = {clientId: this.client.id};

    this.headers = [
      {name: "CASEMAN.PROCESS_GROUP", class: "table-info"},
      {name: "CASEMAN.PROCESS", class: "table-info"},
      {name: "CASEMAN.JOBCODE", class: "table-caseman"},
      {name: "CASEMAN.SUBCODE", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.refresh();

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  refresh() {
    let mappers;
    if (this.client.projectId === undefined) {
      mappers = this.client.teamId
        ? this.Caseman.getProcessMappersByTeamId(this.client.teamId, this.client.id)
        : this.Caseman.getProcessMappersByClientOld(this.client.userId, this.client.id);
    }
    else {
      mappers = this.client.teamId
        ? this.Caseman.getTeamProcessMappersByProjectId(this.client.teamId, this.client.id, this.client.projectId)
        : this.Caseman.getProcessMappersByClient(this.client.userId, this.client.id, this.client.projectId);
    }

    const clients = this.client.teamId
      ? this.Caseman.getClientsByTeamId(this.client.teamId)
      : this.Caseman.getUserClients(this.client.userId);

    Promise.all([mappers, clients]).then(
      (success) => {
        this.clientWorklogsKlix = success[0].data; //id, processId, processName, interruptId, interruptName, processGroupName, casemanProjectId, casemanProjectName, casemanCountry, jobCodeId, jobCodeName, subCodeId, subCodeName
        const userClients = this.client.teamId ? success[1].data : success[1].data.data;
        this.clients = this.client.teamId ? success[1].data : success[1].data.data;

        const currentClient = this.clients.find(client => client.id === this.client.id);
        if (currentClient.additionalInfo) {
          this.client.additionalInfo = currentClient.additionalInfo;
        }

        this.state = "loaded";

        const isInternal = !!userClients.find(c => c.id === this.client.id && c.name.toLowerCase() == "internal");
        this.clientWorklogsKlix.map( worklog => {
          let match = worklog;
          if(!match.casemanProjectId || !match.jobCodeId ) {
            match.unmatched = true;
          }
          return match;
        });
        this.clientProcessesMappers = this.clientWorklogsKlix.filter((worklog) => worklog.processId && worklog).sort(this.Sort.abcBy('processGroupName')); //processGroupName, processId, processName, isProcessHidden
        this.clientInterruptsMappers = this.clientWorklogsKlix.filter((worklog) => worklog.interruptId && worklog && (isInternal ? true : worklog.interruptHasClient)).sort(this.Sort.abcBy('interruptName')); //interruptId, interruptName, isProcessHidden

        if(this.visibilityOfHiddenProcesses && this.visibilityOfHiddenProcesses.checked) {
          this.clientProcessesToDisplay = this.clientProcessesMappers;
          this.clientInterruptsToDisplay = this.clientInterruptsMappers;
        } else {
          this.clientProcessesToDisplay = this.clientProcessesMappers.filter( (mapper) => !mapper.isProcessHidden );
          this.clientInterruptsToDisplay = this.clientInterruptsMappers.filter( (mapper) => !mapper.isProcessHidden );
        }

        this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);

        this.state = "loaded";
        this.setUpClientProject();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  setUpClientProject(){
    let currentClient = this.client;

    function isCurrentClient(currentClient) {
      return function (element) {
        return element.id === currentClient.id;
      };
    }
    //show only current
    this.currentProjects = this.clients.filter(isCurrentClient(currentClient))[0];
    this.currentProjects.projects = this.currentProjects.projects.filter((x) => {
      return x.status === "Active";
    });
  }

  toggleHiddenProcesses() {
    if(this.visibilityOfHiddenProcesses.checked) {
      this.clientProcessesToDisplay = this.clientProcessesMappers;
      this.clientInterruptsToDisplay = this.clientInterruptsMappers;
    } else {
      this.clientProcessesToDisplay = this.clientProcessesMappers.filter( (mapper) => !mapper.isProcessHidden );
      this.clientInterruptsToDisplay = this.clientInterruptsMappers.filter( (mapper) => !mapper.isProcessHidden );
    }
  }

  backToClients() {
    window.history.back();
  }

  clearSelect() {
    this.processToMatch = {clientId: this.client.id};
    this.interruptToMatch = {clientId: this.client.id};
  }

  editProcess(entity) {
    if(entity.id) { // mapper has own id - user made matching
      this.processToMatch.selectedProject = {id: entity.casemanProjectId, name: this.client.projectName, country: entity.casemanCountryCode};
      this.processToMatch.selectedJobcode = {id: entity.jobCodeId, name: entity.jobCodeName};
      this.processToMatch.selectedSubcode = {id: entity.subCodeId, name: entity.subCodeName};

      this.interruptToMatch.selectedProject = {id: entity.casemanProjectId, name: this.client.projectName, country: entity.casemanCountryCode};
      this.interruptToMatch.selectedJobcode = {id: entity.jobCodeId, name: entity.jobCodeName};
      this.interruptToMatch.selectedSubcode = {id: entity.subCodeId, name: entity.subCodeName};

      this.Caseman.getCasemanJobcodes(entity.casemanCountryCode, entity.casemanProjectId).then(
        (success) => {
          this.casemanJobcodes = success.data.sort(this.Sort.abcBy("name")); // id, name, subcodes[]
          const casemanJobcode = this.casemanJobcodes.find( job => job.id == this.processToMatch.selectedJobcode.id);
          this.casemanSubcodes = casemanJobcode && casemanJobcode.subcodes ? casemanJobcode.subcodes : [];
        },
        (error) => {
          this.state = "error";
          this.Notes.postNote({type: "error", error: error});
        }
      );
    } else if(entity.casemanProjectId) { // mapper without id - LA made matching
      this.processToMatch.selectedProject = {id: entity.casemanProjectId, name: entity.casemanProjectName, country: entity.casemanCountryCode};
      this.interruptToMatch.selectedProject = {id: entity.casemanProjectId, name: this.client.projectName, country: entity.casemanCountryCode};
      this.getJobcodes(this.processToMatch.selectedProject);
    }

    this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);
  }

  getJobcodes(select){
    this.Caseman.getCasemanJobcodes(select.country, select.id).then(
      (success) => {
        this.casemanJobcodes = success.data.sort(this.Sort.abcBy("name")); // id, name, subcodes[]
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  getSubcodes(select){
    this.casemanSubcodes = select.subcodes ? select.subcodes : [];
  }

  saveProcessMatch(process,selectedData) {
    this.state = "loading";

    if(!selectedData.selectedProject){
      this.state = "noProject";
      process.edited = true;
    } else if(!selectedData.selectedJobcode){
      this.state = "noJobcode";
      process.edited = true;
    } else {
      const params = {
        clientId: selectedData.clientId,
        processId: process.processId,
        interruptId: process.interruptId,
        projectId: selectedData.selectedProject.id,
        country: selectedData.selectedProject.country,
        jobCodeId: selectedData.selectedJobcode.id,
        subCodeId: selectedData.selectedSubcode && selectedData.selectedSubcode.id
      };

      if (this.client.userId)
        params.userId = this.client.userId;
      else
        params.teamId = this.client.teamId;

      const setProcessResponse = this.client.userId
        ? this.Caseman.setProcessMatch(params)
        : this.Caseman.setProcessMatchForTeam(params);

      setProcessResponse.then(
        () => {
          this.refresh();
          this.clearSelect();
        },
        (error) => {
          this.state = "error";
          this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
  }

  saveProcessEdit(process, selectedData) {
    this.state = "loading";

    if(!selectedData.selectedProject){
      this.state = "noProject";
      process.edited = true;
    } else if(!selectedData.selectedJobcode){
      this.state = "noJobcode";
      process.edited = true;
    } else {
      const params = {
        id: process.id,
        clientId: selectedData.clientId,
        processId: process.processId,
        interruptId: process.interruptId,
        projectId: selectedData.selectedProject.id,
        country: selectedData.selectedProject.country,
        jobCodeId: selectedData.selectedJobcode.id,
        subCodeId: selectedData.selectedSubcode && selectedData.selectedSubcode.id
      };

      if (this.client.userId)
        params.userId = this.client.userId;
      else
        params.teamId = this.client.teamId;

      if (process.id) {
        this.edit = this.client.userId
          ? this.Caseman.editProcessMatch(params)
          : this.Caseman.editProcessMatchForTeam(params);
      } else {
        this.edit = this.client.userId
          ? this.Caseman.setProcessMatch(params)
          : this.Caseman.setProcessMatchForTeam(params);
      }

      this.edit.then(
        () => {
          this.refresh();
          this.clearSelect();
        },
        (error) => {
          this.state = "error";
          this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }

  }

  deleteProcess(process) {
    this.state = "loading";

    const deleteProcessMatchResponse = this.client.userId
      ? this.Caseman.deleteProcessMatch(process.id)
      : this.Caseman.deleteProcessMatchForTeam(process.id);

    deleteProcessMatchResponse.then(
      () => {
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancelProcess() {
    this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);
    this.clearSelect();
    this.state = "loaded";
  }

  cancelInterrupt() {
    this.matchBlocked = this.Utils.blockMatch([...this.clientProcessesToDisplay,...this.clientInterruptsToDisplay]);
    this.clearSelect();
    this.state = "loaded";
  }

  decodeProjectName(name){
    if(name === undefined) return '';
    else return ' - (' + `${this.client.additionalInfo ? "(" + this.client.additionalInfo + ") " : ''}` + decodeURI(name) + ')';
  }

  isMoreThenOneProjectAvailable(client){
    if(client.projects !== undefined){
      return client.projects.length > 1;
    }
  }

  openProjectProcesses(project) {
    if (this.client.userId)
      this.$location.path('/caseman/customize/client/' + project.clientId + '/user/' + this.client.userId + '/name/' + this.client.userName + '/project/' + project.id + '/projectName/' + encodeURI(project.name.replace(/\//g, '')));
    else
      this.$location.path('/caseman/customize/client/' + project.clientId + '/team/' + this.client.teamId + '/name/' + this.client.teamName + '/project/' + project.id + '/projectName/' + encodeURI(project.name.replace(/\//g, '')));
  }

  displayExtraField(selectedValue) {
    if (selectedValue && selectedValue.id)
      return ` [${selectedValue.id}]`;
  }
}
